import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import Button from '../Components/Button';

const LeaderboardSection = () => {
  const { isDarkMode } = useTheme();

  return (
    <section className={`relative py-24 px-4 ${isDarkMode ? 'bg-[#000000]' : 'bg-white'} overflow-hidden`}>
      {/* Background Canvas with Dots */}
      <div className="absolute inset-0">
        <div 
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: `radial-gradient(circle at center center, ${isDarkMode ? '#FFFFFF' : '#666666'} 1.5px, transparent 1.5px)`,
            backgroundSize: '24px 24px',
            backgroundPosition: 'center center'
          }}
        />
      </div>

      <div className="max-w-[1300px] mx-auto relative z-10">
        {/* Header Content */}
        <div className="text-center max-w-[800px] mx-auto mb-12">
          <motion.h2 
            className={`text-[24px] md:text-[32px] lg:text-[36px] font-lexend font-bold ${isDarkMode ? 'text-white' : 'text-black'} mb-4`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Climb the Leaderboard and Earn Your Spot Among the Best
          </motion.h2>
          
          <motion.p 
            className={`text-[14px] md:text-[16px] lg:text-[18px] font-lexend ${isDarkMode ? 'text-white' : 'text-black'} mb-8`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Track your progress, showcase your achievements, and compete with the brightest minds in data science.
          </motion.p>
        </div>

        {/* Leaderboard Image */}
        <motion.div 
          className="max-w-[900px] mx-auto mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <div className={`relative w-full pt-[67%] sm:h-[605px] sm:pt-0 overflow-hidden rounded-[20px] border ${
            isDarkMode ? 'border-[#3E3C33]' : 'border-gray-200'
          }`}>
            <img 
              src="/assets/Leaderboard.gif" 
              alt="Leaderboard" 
              className="absolute top-0 left-0 w-full h-full object-cover"
            />
          </div>
        </motion.div>

        {/* Features List */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 max-w-[900px] mx-auto mb-12 px-6 md:px-0">
          <motion.div
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <p className={`text-[14px] md:text-[16px] font-lexend font-light ${isDarkMode ? 'text-white' : 'text-black'} max-w-[280px] mx-auto`}>
              Real-Time Rankings: Stay updated with live scores and rankings.
            </p>
          </motion.div>

          <motion.div
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            <p className={`text-[14px] md:text-[16px] font-lexend font-light ${isDarkMode ? 'text-white' : 'text-black'} max-w-[280px] mx-auto`}>
              Unlock badges and milestones for your contributions.
            </p>
          </motion.div>

          <motion.div
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
          >
            <p className={`text-[14px] md:text-[16px] font-lexend font-light ${isDarkMode ? 'text-white' : 'text-black'} max-w-[280px] mx-auto`}>
              Gain visibility and recognition in the AI community.
            </p>
          </motion.div>
        </div>

        {/* CTA Button */}
        <motion.div 
          className="flex justify-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6 }}
        >
          <Button 
            text="Participate Now"
            className="gradient"
            link="https://app.lunor.quest/"

          />
        </motion.div>
      </div>
    </section>
  );
};

export default LeaderboardSection; 